// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import { getUniversForUrl } from '../../project/helpers';
import baseQuery from '../baseQuery';
import { UniversInfo } from './universModels';

export const universApi = createApi({
  reducerPath: 'universApi',
  baseQuery: baseQuery('univers'),
  endpoints: (builder) => {
    return {
      getUnivers: builder.query<UniversInfo, string>({
        query: (univers) => {
          return {
            url: getUniversForUrl(univers, true),
            method: 'get',
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUniversQuery, useLazyGetUniversQuery } = universApi;
